<template>
    <div id="listCheck">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Check List</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportCheck()">
                        <i class="fp-export"></i> Export
                    </a>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content check-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'checkList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange" :moduleName="'checkList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listCheckTable"
                                      mode="remote"
                                      title="Checks"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-select-all="onSelectAll"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: check_value,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <!-- <router-link v-if="canUpdateCheck" title="Edit Check" class="glyphicon glyphicon-edit" v-bind:to="{name: 'CheckEdit',params:{id:props.row.id}}"></router-link> -->
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <template>
                                              <button v-if="showReassignBtn" id="showReassignBtn" v-on:click.prevent="openReasonModal('cancel')" class="btn btn-primary">Cancel</button>
                                              <button v-if="showCancelBtn" id="voidPaymentBtn" v-on:click.prevent="openReasonModal('void')" class="btn btn-secondary">Void</button>
                                          </template>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>

                          <div class="modal fade void-reason-modal" id="void-reason-modal" ref="voidReasonModal" data-backdrop="static" data-keyboard="false" aria-labelledby="voidReasonModal" aria-hidden="true">
                              <div class="modal-dialog modal-lg" role="document">
                                  <div class="modal-content">
                                      <div class="modal-header">
                                          <h5 class="modal-title">Please Enter Reason</h5>
                                          <button type="button" class="close" data-dismiss="modal">&times;</button>
                                      </div>
                                      <div class="modal-body">
                                          <div class="form-row">
                                              <div class="col form-group">
                                                  <textarea class='form-control rounded-0' v-model="reason" ref="textarea" id="reason" rows="3"></textarea>
                                                  <div class="field-error">{{reason_error_msg}}</div>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="modal-footer">
                                          <button class="btn btn-primary" id="submitReasonBtn" v-on:click="submitComment()"> Submit </button>
                                      </div>
                                  </div>
                              </div>
                          </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import EventBus from ".././event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
    name: "CheckList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Check List | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        actionFor: "",
        reason:"",
        reason_error_msg:"",
        showReassignBtn: false,
        showCancelBtn:false,
        firstLoad : 0,
        userColumns:[],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
            },
            {
                label: '#Check',
                field: 'check_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Check #", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Type',
                field: 'type',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Vendor',
                field: 'vendor',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vendor", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Amount',
                field: 'amount',
                filterable: true,
                fpFieldType:"integer",
                hidden:false,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Pay Cycle Date',
                field: 'pay_cycle_date',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Pay Cycle Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Run By',
                field: 'run_by',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Run By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Created By',
                field: 'created_by',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Reason',
                field: 'comment',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Reason", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        totalRecords: 0,
        permissions:[],
        loading:false,
        cantAccessPage:"",
        check_value:true,
        canAddCheck:false,
        canUpdateCheck:false,
        pageKey:"_check_list",
        action:'list',
        batchProcess:0,
        batchNum:"",
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_check') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'add_check') {
                    self.canAddCheck = true;
                    self.canUpdateCheck = true;
                }
            });
        }
    },
    created: function() {
    },
    mounted: function () {

        this.getPermissions();

    },
    methods: {
        openReasonModal(actionFor) {
            var self = this;
            $("#void-reason-modal").modal("show");
            self.actionFor = actionFor;
        },
        ReassignPayment() {
          var self = this;
          var rowData = self.$refs['listCheckTable'].selectedRows;
            var data = [];
            var statusArr = [];
            for(var i = 0;i < rowData.length; i++){
                data.push(rowData[i].payment_id);
            }
            console.log("data ===", data);
            // /

            $.ajax({
                    url: process.env.ROOT_API + "/vendor-payment/reassign",
                    type: "POST",
                    data: {
                      payments: data,
                      reason: self.reason
                      },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            self.hideReasonModal();
                            self.$swal('','Check Status Updated Successfully.','success');
                            self.cancelAll(true);
                            self.loadList();
                        }else{
                            $("#confirmStatusBtnPreview").prop("disabled", false);
                            $("#cancelStatusBtnPreview").prop("disabled", false);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'change-payment-status');
                    }
                });
        },
        submitComment() {
          var self = this;
          var error = false;

          if(self.actionFor == 'cancel') {
            self.ReassignPayment();
          } else {
            self.reason_error_msg = "";

            if(self.reason == "" || !self.reason){
                self.reason_error_msg = "Reason Required.";
                error = true;
            }

            if(self.reason.trim() == ""){
                self.reason_error_msg = "Reason Required.";
                error = true;
            }

            if(!error){
                self.changeStatus('reason','void');
            }
          }

        },
        changeStatus(flag,status) {
            var self = this;
            var newStatus = status;

            var rowData = self.$refs['listCheckTable'].selectedRows;
            var data = [];
            var statusArr = [];
            for(var i = 0;i < rowData.length; i++){
                data.push(rowData[i].payment_id);
            }

            // if ( self.selectedPaymentId != "" ) {

                if (flag == "list") {
                    $("#confirmPaymentBtn").prop("disabled", true);
                    $("#deletePaymentBtn").prop("disabled", true);
                } else if(flag == "reason") {
                    $("submitReasonBtn").prop("disabled",true);
                } else {
                    $("#confirmStatusBtnPreview").prop("disabled", true);
                    $("#cancelStatusBtnPreview").prop("disabled", true);
                }

                self.loading = true;
                if (newStatus == "confirmed" ) {
                    var fields = {
                        arr:data,
                        status:newStatus,
                    }
                }else{
                    var fields = {
                        arr:data,
                        status:newStatus,
                        reason:self.reason
                    }
                }

                $.ajax({
                    url: process.env.ROOT_API + "/vendor-payment/change-status",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (flag == "list") {
                            $("#confirmPaymentBtn").prop("disabled", false);
                            $("#deletePaymentBtn").prop("disabled", false);
                        } else if (flag == "reason") {
                            $("submitReasonBtn").prop("disabled",false);

                        } else{
                            $("#confirmStatusBtnPreview").prop("disabled", false);
                            $("#cancelStatusBtnPreview").prop("disabled", false);
                        }

                        if (data.status == "success") {

                            if (flag == "list") {
                                // self.hideModal();
                                self.$swal('','Check Status Updated Successfully.','success');
                            } if ( flag == "reason") {
                                self.hideReasonModal();
                                // self.closeCheckPreview();
                                self.$swal('','Check Status Updated Successfully.','success');
                            } else {
                                // self.closeCheckPreview();
                                self.$swal('','Check Status Updated Successfully.','success');
                            }
                            self.cancelAll(true);
                            self.loadList();
                        }else{
                            if (flag == "list") {
                                $("#confirmPaymentBtn").prop("disabled", false);
                                $("#deletePaymentBtn").prop("disabled", false);
                            } else if (flag == "reason") {
                                $("submitReasonBtn").prop("disabled",false);

                            } else{
                                $("#confirmStatusBtnPreview").prop("disabled", false);
                                $("#cancelStatusBtnPreview").prop("disabled", false);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        if (flag == "list") {
                            $("#confirmPaymentBtn").prop("disabled", false);
                            $("#deletePaymentBtn").prop("disabled", false);
                        }else if (flag == "reason") {
                            $("submitReasonBtn").prop("disabled",false);

                        }else{
                            $("#confirmStatusBtnPreview").prop("disabled", false);
                            $("#cancelStatusBtnPreview").prop("disabled", false);
                        }
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'change-payment-status');
                    }
                });
            // }
        },
        hideReasonModal(){
            var self = this;
            $("#void-reason-modal").modal("hide");
            self.reason = "";
            self.reason_error_msg = "";
        },
        cancelAll: function (cancelAll) {
              this.$refs.listCheckTable.unselectAllInternal();
            },
        // selectionChanged(param) {
        //         var self = this;
        //         if(param.selectedRows.length == 100) {
        //           EventBus.$emit('clear-selection', false);
        //         } else {
        //           EventBus.$emit('clear-all-flags', false);
        //         }
        //         // console.log(self.computed.selectedRows);
        //         // var rowData = self.$refs['my-table'].selectedRows;
        //         // console.log(rowData);
        //     },
        selectionChanged:function(param){
            var self = this;
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }

            var rowData = self.$refs['listCheckTable'].selectedRows;
            self.showReassignBtn = false;
            self.showCancelBtn = false;
            if ( rowData.length > 0){
                for(var i = 0; i < rowData.length; i++){
                    console.log(rowData[i].status);
                    if ( rowData[i].status == "In Progress") {
                      self.showReassignBtn = true;
                    } else {
                      self.showReassignBtn = false;
                    }
                    if ( rowData[i].status == "Print") {
                        self.showCancelBtn = true;
                    } else {
                        self.showCancelBtn = false;
                    }
                }
            }
        },
        exportCheck: function() {
            var self = this;
            var count = 0;
            var actionFlag = "";
            var data = this.$refs['listCheckTable'].selectedRows;
            count = data.length;

            if(this.serverParams.selectedAll == true){
                actionFlag = "";
            }else if(count != 0 && count <= 100){
                actionFlag = "export";
            }

            this.exportReports(actionFlag);
        },
        loadList() {
            var self = this;
            self.loading = true;
            var data = this.$refs['listCheckTable'].selectedRows;

            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(this.$refs['listCheckTable'].selectedRows[i].id)
            }
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action,
                all:self.serverParams.selectedAll,
                selectedRows:use,
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/check/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                        if ( self.action == "export" ||  self.action == "export_queue") {
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                              if ( self.action == "export" ) {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }
                          }
                          self.action = "list";
                          self.loadList();
                        }else {

                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            self.$router.push("/");
                        }
                        self.error = jqXHR.responseJSON.message;
                    }
                }
            });
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/check/CheckList.vue